// One place for every contact channel the page offers.

// Paste the public link of your scheduling tool here (Cal.com, Calendly,
// Google Calendar appointment page...). While it is empty, "Book a consultation"
// collects a proposed day and time and hands it to the brief form instead.
export const BOOKING_URL = '';

export const BRIEF_ENDPOINT = 'https://api.pfaff.app/';

export const PHONE = '+48 533 663 534';
export const PHONE_HREF = 'tel:+48533663534';
export const EMAIL = 'kamil@pfaff.app';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/kamil-pfaff/';
export const GITHUB_URL = 'https://github.com/pfaffkam';
